define('util/externalInclude',[
    'extensions/knockout.amdTemplateEngine',
    'jquery',
    'lib/bluebird',
    'lib/knockout',
    'require',
    'services/loggingService'
], function (amdTemplateEngine, $, Promise, ko, require, log) {
    'use strict';
    ko.setTemplateEngine(new ko.amdTemplateEngine());

    var loadTemplate = function (templateName) {
        var fullName = 'text!' + templateName + '.html';

        if (require.defined(fullName)) {
            // If a template has already been loaded, just resolve immediately
            // Promise.resolve will resolve with a microtask.  If you call the async require
            // with callbacks, it will use setTimeout, which is a macrotask and will allow
            // DOM repaints to happen.
            return Promise.resolve(require(fullName));
        }

        return new Promise(function (resolve, reject) {
            require([fullName],
                function (template) {
                    log.trace('Loaded template: ' + templateName);
                    resolve(template);
                },
                function (error) {
                    log.trace('Failed to load template: ' + templateName);
                    reject(error);
                }
            );
        });
    };

    /*
        A utility class that will help with asynchronously loading templates into the
        browser. This class is meant to be primarily used in binding handlers that will
        render templates.
    */
    var IncludeTemplate = {

        /*
         * Asynchronously load the requested template from the server. This method will
         * return a promise. If the template is already loaded into the page, the promise
         * will automatically resolve itself.
         *
         * @param {string} templateName - The name of the template to load.
         * @return {promise} a promise that will resolve once the request to load the
         *                   template is completed. No arguments will be passed on success.
        */
        loadTemplate: function (templateName) {
            return loadTemplate(templateName);
        }
    };

    return IncludeTemplate;
});

